import React, { forwardRef } from 'react';
import { Text, TextProps } from '../Text';

/**
 * @deprecated use `ParagraphText` or `UtilityText` from `genesis-core` instead
 */

export const BodyOne = forwardRef<HTMLElement, TextProps>((props, ref) => (
  <Text
    as="p"
    color="onSurface.text.primary"
    typography="bodyOne"
    ref={ref}
    {...props}
  />
));

BodyOne.displayName = 'BodyOne';
